import { IQuestionsGroupProps } from 'app/components/questions/base'
import { Container } from 'app/containers/Container'
import { ExpenseQuestionGroups, ExpenseQuestionGroupsKeys } from 'app/containers/PipelineSection/Expenses'
import { PensionQuestionGroups, PensionQuestionGroupsKeys } from 'app/containers/PipelineSection/Pension'
import { ResultsKeys, ResultsSection } from 'app/containers/PipelineSection/Results'
import { RetirementQuestionGroups, RetirementQuestionGroupsKeys } from 'app/containers/PipelineSection/Retirement'
import { SSAQuestionGroups, SSAQuestionGroupsKeys } from 'app/containers/PipelineSection/SSA'
import * as _ from 'lodash'

const QuestionGroups = _.extend({}, ExpenseQuestionGroups, PensionQuestionGroups, RetirementQuestionGroups,
  SSAQuestionGroups, ResultsSection)

type QuestionGroupsKey = ExpenseQuestionGroupsKeys | PensionQuestionGroupsKeys | RetirementQuestionGroupsKeys
  | SSAQuestionGroupsKeys | ResultsKeys

export {
  QuestionGroups,
  QuestionGroupsKey,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/QuestionGroups.ts